import { useEffect, useMemo, useState } from "react"
import { SOCKET_URL } from "../../../core/constants/urls"
import { useProfileQuery } from "../../../core/services/react-query/useInternalTransfer"
import { formatDate, formatNumber } from "../../../core/utils/common"
import { Text } from "../../../modules/staking"
import Loading from "../../../pages/trade/common/Loading"
import NoData from "../../../pages/trade/history/NoData"
import { usePersianNames } from "../../../pages/trade/utils"
import { Column, Row } from "../../../styles/TableStyle"
import FilterLayout from "../../layouts/FilterLayout"
import { useOrdersHistoryQuery } from "../../../pages/trade/utils/useHistory"
import MobileModal from "../../modals/MobileModal"
import P2PTradeDetailsModal from "./P2pDetailsModal"

const initialModalState = { show: false, data: null }
const RP2PHistoryTable = () => {


    const [modal, setModal] = useState(initialModalState)
    const onCloseModal = () => setModal(initialModalState)

    const { data: profile, isLoading: loadingProfile } = useProfileQuery()
    const { findPersianName } = usePersianNames()

    const initialState = {
        page: 1,
        dateFrom: null,
        search: {
            _id: '_id'
        },
        query: {
            _id: ''
        },
    }

    const [filterQueries, setFilterQueries] = useState(initialState)

    const { data: history, isLoading, refetch } = useOrdersHistoryQuery(filterQueries)

    const totalPages = useMemo(() => history?.meta?.total || 0, [history])


    useEffect(() => {
        refetch()
    }, [filterQueries, refetch])

    return (
        <>
            <FilterLayout
                data={history}
                totalPages={totalPages}
                headers={headers}
                loading={isLoading}
                state={{
                    filterQueries: filterQueries,
                    setFilterQueries: setFilterQueries,
                    initialState,
                }}
            >
                {history?.data?.map((trade, idx) => {
                    let tradeType = trade.order?.type
                    if (profile?._id !== trade.order?.userId) {
                        tradeType = tradeType === 'buy' ? 'sell' : 'buy'
                    }

                    return (
                        <Row
                            onClick={() => { setModal({ data: trade, show: true }) }}
                            key={trade._id}
                        >
                            {/* بازار */}
                            <Column className="w-[33.333%]">
                                <div className="flex flex-col items-center gap-2">
                                    <img
                                        width={26}
                                        height={26}
                                        src={SOCKET_URL + `assets/icon/${trade?.coin?.toLowerCase()}.png`}
                                        alt={`${trade.coin?.toLowerCase()}.png`}
                                    />
                                    <div className="flex flex-col">
                                        <span className="whitespace-nowrap">
                                            {`${trade.coin?.toUpperCase()} / ${trade.pair?.toUpperCase()}`}
                                        </span>
                                        <span className="text-gray-400 text-xs whitespace-nowrap">
                                            {`${findPersianName(trade.coin)} / ${findPersianName(trade.pair)}`}
                                        </span>
                                    </div>
                                </div>
                            </Column>

                            {/* مقدار سفارش */}
                            <Column className="w-[33.333%]">
                                {formatNumber(trade.order?.amount, { type: trade.coin })}
                            </Column>

                            {/* وضعیت */}
                            <Column className="w-[33.333%]">
                                {trade.order?.status}
                            </Column>
                        </Row>
                    )
                })}
            </FilterLayout>
            {!loadingProfile &&
                <MobileModal isOpen={modal.show} onClose={onCloseModal}>
                    <P2PTradeDetailsModal data={modal.data} profileId={profile._id} onClose={onCloseModal} />
                </MobileModal>
            }
        </>
    )
}

const headers = [
    { title: 'بازار', width: 'w-[33.333%]' },
    { title: 'مقدار سفارش', width: 'w-[33.333%]' },
    { title: 'وضعیت', width: 'w-[33.333%]' },
]

export default RP2PHistoryTable
